import { styled } from 'styled-system/jsx'

const AutopayStack = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    width: '100%',
  },
})

const AutopayHeader = styled('div', {
  base: {},
})

const AutopayTitle = styled('h1', {
  base: {
    fontFamily: 'display',
    fontSize: '28px',
    fontWeight: '700',
    color: 'quickpass.ink',
  },
})

const AutopaySubtitle = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '15px',
    color: 'quickpass.inkSoft',
    marginTop: '4px',
  },
})

const ExplainerList = styled('ul', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    paddingLeft: '18px',
    listStyle: 'disc',
  },
})

const ExplainerItem = styled('li', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: 'quickpass.inkSoft',
    lineHeight: 1.5,
  },
})

const ElementContainer = styled('div', {
  base: {
    marginTop: '20px',
  },
})

const SetupActions = styled('div', {
  base: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '12px',
    marginTop: '20px',
  },
})

const SetupErrorText = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    fontWeight: '600',
    color: '#9B3B3B',
    marginTop: '12px',
  },
})

const QuietNote = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: 'quickpass.inkSoft',
  },
})

const BackLink = styled('button', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    fontWeight: '600',
    color: 'quickpass.primary',
    backgroundColor: 'transparent',
    border: 'none',
    padding: '0',
    cursor: 'pointer',
    transition: 'opacity {durations.fast} {easings.appleStandard}',
    _hover: {
      opacity: '0.7',
    },
  },
})

export {
  AutopayStack,
  AutopayHeader,
  AutopayTitle,
  AutopaySubtitle,
  ExplainerList,
  ExplainerItem,
  ElementContainer,
  SetupActions,
  SetupErrorText,
  QuietNote,
  BackLink,
}
